import { tabService } from '@src/TabService';
import { Pages } from '../Pages';
import { FeatureFlags } from '@src/featureFlags';

export interface NavigationLink {
  page?: string
  title: string
  iconClass: string
  isDisabled?: boolean
  isRestricted?: boolean
  isHidden?: boolean
  onClick?: () => void
}

/**
 * @param {boolean} isMachineAppAvailable Whether the machine app is available.
 * @param {boolean} hasFullAccess Whether the user has full access. I don't really know what this means, you got me.
 * @param {boolean} lockInAppLauncher Whether the use is locked to AppLauncher page or not
 * @return {NavigationLink[]} The newly created list of navigation links.
 */
export const getNavigationLinks = (isMachineAppAvailable: boolean, hasFullAccess: boolean, lockInAppLauncher: boolean): NavigationLink[] => {
  return [
    {
      page: Pages.MACHINE_CONFIG,
      title: 'Configuration',
      iconClass: 'icon-cogs',
      isDisabled: true,
    },
    {
      page: Pages.NETWORK_CONFIG,
      title: 'Network',
      iconClass: 'icon-network-connection',
      isDisabled: true,
    },
    {
      page: Pages.JOGGER,
      title: 'Manual Control',
      iconClass: 'icon-jogger_inactive',
      isDisabled: true,
    },
    {
      page: Pages.MACHINE_LOGIC,
      title: 'MachineLogic',
      iconClass: 'icon-launch-sequence-editor',
      isDisabled: true,
      isRestricted: !hasFullAccess,
    },
    {
      page: Pages.UI_BUILDER,
      title: 'UI Builder',
      iconClass: 'icon-edit',
      isDisabled: lockInAppLauncher,
      isHidden: !FeatureFlags.SHOW_UI_BUILDER_NAVIGATION,
    },
    {
      title: 'MachineApp',
      iconClass: 'icon-machine-app',
      isDisabled: lockInAppLauncher,
      isHidden: !isMachineAppAvailable,
      onClick: () => { tabService.switchTo('machine-app'); },
    },
    {
      page: Pages.MACHINE_APP,
      title: 'MachineApps',
      iconClass: 'icon-machine-app',
      isDisabled: false,
    },
    {
      page: Pages.APP_LAUNCHER,
      title: 'App Launcher',
      iconClass: 'icon-launch',
      isRestricted: !hasFullAccess,
    },
  ];
};
